import { SDSSwitch } from '@repo/sds/SDSSwitch';
import { TimeFormat } from '@repo/ui/constants/timezone';
import { useTimezone } from '@repo/ui/hooks/use-timezone';

import './TimeModeToggle.scss';

export function TimeModeToggle() {
  const { timeFormat, updateTimeFormat } = useTimezone();

  const handleTimeFormatChange = () => {
    const newFormat = timeFormat === TimeFormat.ampm ? TimeFormat['24hr'] : TimeFormat.ampm;
    updateTimeFormat(newFormat);
  };

  return (
    <div className="TimeModeToggle">
      <div className="TimeModeToggle__title">Time zone</div>
      <div className="TimeModeToggle__switch">
        <div>am/pm</div>
        <SDSSwitch
          checked={timeFormat === TimeFormat['24hr']}
          onChange={handleTimeFormatChange}
          aria-label="Toggle 24-hour time format"
        />
        <div>24h</div>
      </div>
    </div>
  );
}
